import React, { useState } from 'react';
import groupBy from 'lodash.groupby';
import { TableBody, Table, TableHead, TableRow, TableCell } from '@material-ui/core';
import { PreviewRounded } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';

import { TableBox } from 'retired/Box';
import { Details } from 'components/Details';
import {
  IgnorableNotificationMessageCategory,
  NotificationSettingsPageQuery,
} from 'generated/graphql';

import { CategorySwitch } from './CategorySwitch';
import { MessageSwitch } from './MessageSwitch';
import { EmailTemplateModal } from './EmailTemplateModal';

export type NotificationMessage = NonNullable<
  NonNullable<NotificationSettingsPageQuery['notificationMetadata']>['messages']
>[number];

export const NotificationSettingsForm = ({ data }: { data: NotificationSettingsPageQuery }) => {
  const [selectedTemplate, setSelectedTemplate] = useState<NotificationMessage | null>(null);

  const groupedMessages = groupBy(data.notificationMetadata?.messages ?? [], 'category') as Record<
    string,
    NotificationMessage[]
  >;

  return (
    <>
      {Object.keys(groupedMessages).map((categoryId) => {
        const messages = groupedMessages[categoryId];
        const currentCategory = data.notificationMetadata?.categories?.find(
          (category) => category?.id === categoryId
        );
        return (
          <Details
            key={categoryId}
            label={currentCategory?.label || ''}
            summary={
              <CategorySwitch
                data={data}
                categoryId={categoryId as IgnorableNotificationMessageCategory}
              />
            }
          >
            <TableBox>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell size="medium" align="left">
                      Notification Name
                    </TableCell>
                    <TableCell size="medium" align="center">
                      Preview
                    </TableCell>

                    <TableCell
                      size="medium"
                      style={{
                        width: '10%',
                      }}
                    >
                      Enable
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {messages.map((message) => {
                    if (!message || typeof message !== 'object') {
                      return null;
                    }

                    return (
                      <TableRow key={message.id}>
                        <TableCell size="small">{message.label}</TableCell>
                        <TableCell size="small" align="center">
                          <IconButton
                            style={{ color: '#000', opacity: 0.38 }}
                            aria-label="preview email template"
                            size="large"
                            onClick={() => setSelectedTemplate(message)}
                          >
                            <PreviewRounded fontSize="large" />
                          </IconButton>
                        </TableCell>

                        <TableCell size="small">
                          <MessageSwitch message={message} data={data} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableBox>
          </Details>
        );
      })}

      {selectedTemplate && (
        <EmailTemplateModal
          message={selectedTemplate}
          categories={data.notificationMetadata?.categories ?? []}
          onClose={() => setSelectedTemplate(null)}
        />
      )}
    </>
  );
};
